import React, { Component } from "react";
import { connect } from "react-redux";
import Table from '@mawesi-sas/mws_react_component_table';
import Input from '@mawesi-sas/mws_react_component_input';
import numeral from "numeral";

import Box from "../../Layout/components/Box";
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { getDataFromServer, reiniciarEstado } from "../actions";
import history from "../../../utils/history";

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

class General extends Component {
  componentWillMount() {
    this.props.getDataFromServer();
  }

  handleOnChange = (value) => {
    clearTimeout(this.timer);
    this.setState({ value });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleOnKeyDown = (key) => {
    if (key.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = () => {
    this.props.getDataFromServer();
  };

  render() {
    if (!this.props.elementos) return null;
    const totalSelected = this.props.total;

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div
            className="col-md-12"
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            {this.props.filter && (
              <div className="buttonstrip" style={{ marginTop: "-10px" }}>
                <Input
                  type="text"
                  reducer="interfazcontable"
                  path="filter"
                  afterChange={this.handleOnChange}
                  onKeyDown={this.handleOnKeyDown}
                  placeholder="Filtrar..."
                />
              </div>
            )}
            <div>
              <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-md-3">
                  <div className="form-group" style={{ marginBottom: "0" }}>
                    <Input
                      type="select"
                      reducer="interfazcontable"
                      path="cafeteria"
                      placeholder="Seleccione una cafetería"
                      options={this.props.cafeterias}
                      afterChange={this.triggerChange}
                    />
                  </div>
                </div>
                <div className="col-md-offset-6 col-md-3">
                  <div style={{ textAlign: "right" }}>
                    Total: {numeral(totalSelected).format("$ 0,0.00")}
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                flex: 1,
                padding: "10px 0",
              }}
            >
              <Table
                reducer="interfazcontable"
                table="interfazcontable"
                selectionMode="multiple"
                take={100}
                whenNoData={
                  <div
                    style={{
                      color: "#888",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid rgb(221, 221, 221)",
                      background: "rgb(243, 243, 243)",
                    }}
                  >
                    No se encontraron solicitudes que cumplan con los criterios
                    de busqueda
                  </div>
                }
                columns={[
                  {
                    ID: 0,
                    CAPTION: "",
                    VALUE: "selected",
                    TYPE: "selection",
                    INPUT: "checkbox",
                    WIDTH: 24,
                    FIXED: true,
                  },
                  {
                    ID: 1,
                    CAPTION: "Solicitud",
                    VALUE: "id",
                    TYPE: "text",
                  },
                  {
                    ID: 2,
                    CAPTION: "Motivo",
                    VALUE: "motivo",
                    TYPE: "text",
                  },
                  {
                    ID: 3,
                    CAPTION: "Fecha y hora",
                    VALUE: "fecha_hora",
                    TYPE: "date",
                  },
                  {
                    ID: 4,
                    CAPTION: "Solicitante",
                    VALUE: "solicitante.name",
                    TYPE: "text",
                  },
                  {
                    ID: 5,
                    CAPTION: "Fecha de creación",
                    VALUE: "created_at",
                    TYPE: "date",
                  },
                  {
                    ID: 6,
                    CAPTION: "Recursos",
                    WIDTH: 400,
                    TYPE: "custom",
                    RENDER_ROW: (reg) => {
                      return reg.get("distribuciones").map((x) => {
                        return (
                          <span
                            key={`span[0][${x.get("id")}]`}
                            title={x.getIn("cenco.nombre".split("."))}
                            style={{
                              fontSize: "1em",
                            }}
                            className={`label label-light-grey`}
                          >
                            {x.getIn("cenco.codigo".split("."))}
                            &nbsp;|&nbsp;
                            {x.get("porcentaje")}%
                          </span>
                        );
                      });
                    },
                  },
                  {
                    ID: 7,
                    CAPTION: "Cafetería",
                    VALUE: "nombre_cafeteria",
                    TYPE: "text",
                  },
                  {
                    ID: 8,
                    CAPTION: "Valor total",
                    VALUE: "valor_total",
                    TYPE: "number",
                    FORMAT: "$0,0.00",
                  },
                  {
                    ID: 9,
                    CAPTION: "Estado",
                    WIDTH: 80,
                    TYPE: "custom",
                    RENDER_ROW: (reg) => {
                      const estado = reg.get("estado").toUpperCase();
                      let color = "default";
                      switch (estado) {
                        case "CREADA":
                          color = "info";
                          break;
                        case "APROBADA":
                          color = "warning";
                          break;
                        case "CANCELADA":
                          color = "danger";
                          break;
                        case "COMPLETADA":
                          color = "success";
                          break;
                        case "FACTURADA":
                          color = "primary";
                          break;
                      }
                      return (
                        <span
                          style={{
                            fontSize: "1em",
                            display: "block",
                            margin: "2px 0",
                          }}
                          className={`label label-${color}`}
                        >
                          {reg.get("estado").toUpperCase()}
                        </span>
                      );
                    },
                  },
                ]}
                onCambiarPagina={(pg) => this.props.getDataFromServer(pg)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elementos: state.layout.get("elementos"),
    registros: state.interfazcontable.getIn(
      "interfazcontable.records".split(".")
    ),
    total: state.interfazcontable.getIn("interfazcontable.data".split("."))
      ? state.interfazcontable
          .getIn("interfazcontable.data".split("."))
          .valueSeq()
          .filter((x) => x.get("selected"))
          .reduce((a, b) => {
            a += b.get("valor_total");
            return a;
          }, 0)
      : 0,
    cafeterias: state.interfazcontable.get("cafeterias",[]).toJS() || [],
  };
}

const mapDispatchToProps = {
  reiniciarEstado,
  getDataFromServer,
};

export default connect(mapStateToProps, mapDispatchToProps)(General);
